import React from "react";

function Aboutus() {
  return (
    <>
      <div className="about" id="about">
        <div className="container">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-3  col-lg-6 col-md-8 text-center offset-xl-2">
              <div
                className="donate wow fadeInLeft"
                data-wow-duration="0.5s"
                data-wow-delay="0.5s"
              >
                <h6 className="donate-hade">DONATE CRYPTOCURRENCY</h6>
                <div className="thumb">
                  <img src="images/donate.png" alt="" />
                </div>
                <a href="#donation" className="button-1">
                  {" "}
                  <i className="far fa-heart m-1" /> Donate Now{" "}
                </a>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-7 order-first order-xl-last">
              <div className="section-head">
                <h3
                  className="subtitle wow fadeInDown"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  About Us
                </h3>
                <h2
                  className="title wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  Together We Can Change the World
                </h2>
                <p
                  className="text wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  Cryptocurrency Donation Platform Together, we can build a
                  better world. We built cryptocurrency donation platform to
                  help charities connect with donors in the digital age.
                </p>
              </div>
              <ul className="list">
                <li
                  className="list-item wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  <div className="check">
                    <img src="images/chack.png" alt="" />
                  </div>
                  <p className="text">
                    We use Blockchain technology to offer full transparency of
                    economic flows
                  </p>
                </li>
                <li
                  className="list-item wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  <div className="check">
                    <img src="images/chack.png" alt="" />
                  </div>
                  <p className="text">
                    FREE - No membership fee or hidden costs
                  </p>
                </li>
                <li
                  className="list-item wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  <div className="check">
                    <img src="images/chack.png" alt="" />
                  </div>
                  <p className="text">
                    DECENTRALIZED - There is no third party involve
                  </p>
                </li>
                <li
                  className="list-item wow fadeInUp"
                  data-wow-duration="0.4s"
                  data-wow-delay="0.4s"
                >
                  <div className="check">
                    <img src="images/chack.png" alt="" />
                  </div>
                  <p className="text">
                    100% of donations are sent directly to the charity.
                    Together, we make the world a better place!
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Aboutus;
